import React from 'react';
import './link-to-engage.css';
import { Link } from 'react-router-dom';


let LinkToEngage = () => {
  return (
    <div id="lte-d1a">
      <Link to="/engage"
            id="lte-l1a"
      >
        engage
      </Link>
    </div>
  );
};


export default LinkToEngage;


// WEBPACK FOOTER //
// ./src/components-global/links/LinkToEngage.js